import { Show } from "solid-js";
import { useSession } from "../../session/provider.tsx";
import { DashboardPage } from "../admin/DashboardPage.tsx";
import { CustomerStartPage } from "./CustomerStartPage.tsx";

/**
 * The first screen after signing in. A consultant lands on the dashboard; a
 * customer user, or a consultant previewing one, lands on the customer's Start.
 */
export const StartPage = () => {
  const session = useSession();
  return (
    <Show when={session.isCustomer()} fallback={<DashboardPage />}>
      <CustomerStartPage />
    </Show>
  );
};
